var path = '/app/components/dialogs/feedback/feedback.html';
var html = "<red-stars stars-count=$ctrl.resolve.starCount></red-stars> <div class=feedback-modal> <div class=feedback-header>{{ $ctrl.resolve.title }}</div> <div class=modal-body id=modal-body> <img class=feedback-gesture ng-src={{$ctrl.getGestureImg()}} /> <p ng-bind-html=$ctrl.resolve.text></p> <ul class=\"list-inline actions text-center\"> <li> <a class=btn-reset ng-click=$ctrl.onClickReset()></a> </li> <li ng-show=\"$ctrl.resolve.starCount > 0\"> <a class=btn-forward ng-click=$ctrl.onClickNext()></a> </li> </ul> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/feedback/feedback.html
// module id = 136
// module chunks = 0